import { render, staticRenderFns } from "./qulityAdvice.vue?vue&type=template&id=000f2bdb&scoped=true"
import script from "./qulityAdvice.vue?vue&type=script&lang=js"
export * from "./qulityAdvice.vue?vue&type=script&lang=js"
import style0 from "./qulityAdvice.vue?vue&type=style&index=0&id=000f2bdb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "000f2bdb",
  null
  
)

export default component.exports